<template>
  <transition
    enter-active-class="duration-300 ease-out"
    enter-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="duration-200 ease-in"
    leave-class="opacity-100"
    leave-to-class="opacity-0"
    @leave="destroyPopup"
  >
    <div
      v-if="displayPopup"
      style="z-index: 1000"
      class="fixed bottom-0 w-full p-0 mx-auto sm:p-4 sm:max-w-sm sm:right-0 print:hidden"
    >
      <div
        class="relative p-4 bg-white"
        style="border-radius: 19px; border: 4px solid rgb(3, 185, 219)"
      >
        <img
          v-if="activeBreakpoint === 'sm'"
          :src="randomImage"
          class="w-20 h-20 mx-auto -mt-14"
        />
        <img
          v-else
          :src="randomImage"
          class="absolute top-0 left-0 w-20 h-20 -mt-8 -ml-8"
        />
        <div
          data-test-attr='popup-message'
          class="px-6 pt-4 sm:pl-8 sm:pt-1"
          style="font-size: 17px; font-weight: bold; color: #0e415b"
          v-html="popupNotificationMessage"
        >
          {{ popupNotificationMessage }}
          <!-- 30 Nov, 12:01am to 30 Nov, 9:59am -->
<!--          <p>-->
<!--            #StayMasked in back! Collection and pre-order of MaskPlus Livinguard masks starts from Monday, 1 Mar, 10:00am.-->
<!--          </p>-->

<!--          <p class="mt-4">-->
<!--            Pre-order ends on Saturday, 13 Mar, 11:59pm. Collection of masks from any #StayMasked vending machine ends on Sunday, 14 Mar, 11:59pm.-->
<!--          </p>-->
          <!-- 30 Nov, 10:00am to 4 Dec 11:59pm -->
          <!-- <p>
            What’s your mask size? Measure yourself before collection. Avoid the
            early-bird rush - #KeepCalm as there’s ample stock for all.
            Collection ends Sunday, 13 Dec, 11:59pm.
          </p> -->
          <!-- <p>
            We are aware that our vending machines are facing technical issues.
            Please do not use the machines now. If you’re at the CCs / RCs,
            staff will assist you manually. We are looking into this and will
            share updates soon. We apologise for any inconvenience caused.
          </p> -->
          <!-- <p>
            What’s your mask size? Measure yourself before collection. Pre-order
            ends Saturday, 12 Dec, 11:59pm. Collect your free mask kit and
            pre-ordered mask kits by Sunday, 13 Dec, 11:59pm.
          </p> -->
          <!-- <p>
            Due to planned maintenance, this site (including QR codes) will not
            be available on Wednesday, 2 Dec, from 12:30am to 2:30am.
          </p> -->
          <!-- 5 Dec, 12:00am to 12 Dec 11:59pm -->
          <!-- <p>
            Pre-order ends Saturday, 12 Dec, 11:59pm. Collect your free mask kit and pre-ordered mask kits by Sunday, 13 Dec, 11:59pm.
          </p> -->
          <!-- 13 Dec, 12:00am to 13 Dec 11:59pm -->
          <!-- <p>
            Pre-order has ended. Collect your free and pre-ordered mask kits by
            Sunday, 13 Dec, 11:59pm.
          </p> -->
          <!-- 14 Dec, 12:00am -->
          <!-- <p>
            The StayMasked distribution has ended. Remember to wear your masks and keep a safe distance when you head out!
          </p> -->
        </div>
        <button
          class="absolute top-0 right-0 mt-4 mr-4 focus:outline-none"
          @click="hideAll"
        >
          <svg
            style="height: 24px; width: 24px; color: #0e415b"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clip-rule="evenodd"
            />
          </svg>
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'Popup',
  components: {},
  mixins: [],
  props: {},
  data () {
    if (Date.now() > 1599955200000) {
      return {
        displayPopup: true
      }
    } else {
      return {
        displayPopup: false
      }
    }
  },
  computed: {
    ...mapGetters(['activeBreakpoint', 'popupNotificationMessage']),

    randomImage () {
      const arrayOfImg = [
        'https://cdn1.stayprepared.sg/wp-content/themes/maskup/assets/images/person-1.svg',
        'https://cdn1.stayprepared.sg/wp-content/themes/maskup/assets/images/person-2.svg',
        'https://cdn1.stayprepared.sg/wp-content/themes/maskup/assets/images/person-3.svg',
        'https://cdn1.stayprepared.sg/wp-content/themes/maskup/assets/images/person-4.svg',
        'https://cdn1.stayprepared.sg/wp-content/themes/maskup/assets/images/person-5.svg'
      ]
      const randomIndex = Math.floor(Math.random() * 5)

      return arrayOfImg[randomIndex]
    }
  },
  watch: {},
  created () {
    this.getPopupMessage()
  },
  mounted () {
    this.displayShade = true
  },
  methods: {
    ...mapActions(['getPopupMessage']),
    hideAll () {
      this.displayPopup = false
    },

    destroyPopup () {
      this.$destroy()
    }
  }
}
</script>

<style scoped>
</style>
